import React, { Component } from "react";
import TicketSelectField from "./TicketSelectField";
import SelectBeneficiary from "../components/SelectBeneficiary";
import Button from "./Button";
import { Helmet } from "react-helmet";

class CheckoutTickets extends Component {
  constructor(props) {
    super(props);

    let beneficiaries = [];

    const { context, cart } = props;

    context.event.beneficiaries.forEach(beneficiary => {
      if (beneficiary.logo_url) {
        beneficiaries.push({
          label: <div><img style={{ position: 'relative', borderRadius: '50%', verticalAlign: 'middle', width: '35px', height: '35px' }} src={beneficiary.logo_url} />{beneficiary.name}</div>,
          value: beneficiary.id
        });
      }
      else {
        beneficiaries.push({
          label: beneficiary.name,
          value: beneficiary.id
        });
      }
    })
    this.state = {
      beneficiaries: beneficiaries
    };

    if (+context.event.shopify_enabled === 1) {
      window.location.href = "/";
    }

    // Redirect user to home page if cart's undefined
    if (!cart && window.location.pathname != '/free-tickets/select-tickets') {
      window.location.href = "/";
    }
  }

  render() {
    const { context, cart, handleCart, handleBeneficiary, validateCart, validateCartTickets, valid, goToPrevious, tickets_error, freeTicket } = this.props;
    const { beneficiaries } = this.state;

    return (
      <form className="w-full md:w-2/3">
        <Helmet>
          {context.settings.scripts_select_tickets && <script>{context.settings.scripts_select_tickets}</script>}
        </Helmet>
        <h2 className="mb-6">{freeTicket && freeTicket > 0 ? 'Claim your free ticket' : 'Select Tickets'}</h2>
        {freeTicket > 0 && context.event.title !== "" && <h4>Event: {context.event.title}</h4>}
        <div className="flex flex-wrap mb-6">
          {cart &&
            cart.map((c, k) => (
              <TicketSelectField
                key={k}
                container="w-full flex items-center"
                id={`cart-${k}`}
                label={`${c.tickets} ticket(s) for $${c.cost}`}
                value={c.qty}
                handleChange={handleCart}
                disabled={c.disabled}
              />
            ))}
          {context.event.beneficiaryenabled === 1 &&
            (
              <SelectBeneficiary
                container="w-full pr-3 pl-3 mb-6 md:mb-0"
                id="beneficiaryId"
                name="context.event.beneficiary"
                options={beneficiaries}
                required
                handleBeneficiary={handleBeneficiary}
                label={context.language.en.beneficiary_label}//"Choose a beneficiary"
                placeholder={context.language.en.beneficiary_placeholder}
              />
            )
          }
          {tickets_error && (
            <div className="w-full flex justify-center mt-6">
              <div className="bg-white border border-danger text-danger px-4 py-3 rounded relative" role="alert">
                {
                  tickets_error &&
                  <i className="block md:inline font-bold">{valid.cartTotal}</i>
                }
              </div>
            </div>
          )}
        </div>
        <div className="w-full flex flex-wrap mb-6 justify-center justify-between">
          {!freeTicket &&
            <Button
              onClick={goToPrevious}
              color="secondary"
              textColor="primary"
              content={"Back"}
            />
          }
          {context.event.game.id === 3 ?
            <Button color="accent" textColor="primary" onClick={validateCart} content={"Continue"} continueButton="true"/>
            :
            <Button color="accent" textColor="primary" onClick={validateCartTickets} content={"Continue"} continueButton="true"/>
          }
        </div>
      </form>
    );
  }
}

export default CheckoutTickets;
